import { Button } from "react-bootstrap";

export default function PreOrderCodeSelectAllButton({
  selected,
  setSelected,
  items,
}) {
  const canBeSelected = items
    .filter(item => !item.total_post)
    .map(item => item.id);

  const isAllSelected = canBeSelected.length === selected.length;

  const onClick = () => {
    if (isAllSelected) {
      setSelected([]);
      return;
    }
    setSelected([...canBeSelected]);
  };

  return (
    <Button variant="outline-primary" onClick={onClick}>
      {isAllSelected && <span>پاک کردن</span>}
      {!isAllSelected && <span>انتخاب همه</span>}
    </Button>
  );
}
